import React from 'react';
import { motion } from 'framer-motion';

const BlogCategoryBar = ({ categories, activeCategoryId, onSelectCategory, loading }) => {
    if (loading) return (
        <div className="flex gap-2 overflow-x-auto pb-4 no-scrollbar">
            {[1, 2, 3, 4, 5].map(i => (
                <div key={i} className="h-10 w-24 bg-gray-100 animate-pulse rounded-full flex-shrink-0" />
            ))}
        </div>
    );

    return (
        <div className="flex gap-2 overflow-x-auto pb-4 no-scrollbar -mx-2 px-2">
            <motion.button
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                onClick={() => onSelectCategory(null)}
                className={`px-6 py-2 rounded-full text-sm font-medium transition-all duration-200 flex-shrink-0
                    ${!activeCategoryId
                        ? 'bg-blue-600 text-white shadow-md'
                        : 'bg-white text-gray-600 hover:bg-gray-100 border border-gray-200'}`}
            >
                All Stories
            </motion.button>
            {categories.map((category) => (
                <motion.button
                    key={category.id}
                    whileHover={{ scale: 1.05 }}
                    whileTap={{ scale: 0.95 }}
                    onClick={() => onSelectCategory(category.id)}
                    className={`px-6 py-2 rounded-full text-sm font-medium transition-all duration-200 flex-shrink-0
                        ${category.id === activeCategoryId
                            ? 'bg-blue-600 text-white shadow-md'
                            : 'bg-white text-gray-600 hover:bg-gray-100 border border-gray-200'}`}
                >
                    {category.name}
                </motion.button>
            ))}
        </div>
    );
};

export default BlogCategoryBar;
